import { playVideo as playVideoAction } from 'common/actions';
import variables from 'common/config/variables';
import { Epg } from 'common/constants/data-types';
import { calculateTimePercentages } from 'common/services/helpers';
import { AppDispatch } from 'index';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export interface PlayVideoAction {
  startPosition?: number;
  hash?: string;
  channelPosition?: number | null;
  vod?: boolean;
  isFullscreen?: boolean;
  vodAsset?: Epg;
}

interface ContinueWatchingOptions {
  continueWatching?: boolean;
}

function usePlayerActions() {
  const dispatch = useDispatch<AppDispatch>();

  const playVideo = useCallback(
    (epg: Epg, options: PlayVideoAction) => {
      dispatch(playVideoAction(epg, options));
    },
    [dispatch]
  );

  const playVideoFromContinueWatching = useCallback(
    (epg: Epg, options: PlayVideoAction & ContinueWatchingOptions) => {
      let startPosition = (options.continueWatching && epg.skips?.continue?.offset) || -1;
      if (startPosition > 0) {
        const percentageWatched = calculateTimePercentages(
          epg.start,
          epg.stop,
          startPosition + epg.start
        );
        const timeLeft = epg.stop - epg.start - startPosition;
        startPosition =
          percentageWatched >= variables.CONTINUE_WATCHING_RESET_PERCENTAGE ||
          timeLeft <= variables.CONTINUE_WATCHING_RESET_SECONDS_LEFT
            ? 0
            : startPosition;
      }
      playVideo(epg, { startPosition, ...options });
    },
    [playVideo]
  );

  const playVideoVod = useCallback(
    (epg: Epg, options: PlayVideoAction) => {
      playVideoFromContinueWatching(
        { ...epg, chan_id: epg.id },
        { ...options, vod: true, vodAsset: epg }
      );
    },
    [playVideoFromContinueWatching]
  );

  return { playVideo, playVideoFromContinueWatching, playVideoVod };
}

export default usePlayerActions;
